import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-809c31d6")

_pushScopeId("data-v-809c31d6")
const _hoisted_1 = {
  key: 0,
  class: "fixed top-0 flex justify-center w-screen pointer-events-none"
}
const _hoisted_2 = { class: "text-sm" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_fa = _resolveComponent("fa")

  return (_openBlock(), _createBlock(_Transition, { name: "slide-fade" }, {
    default: _withId(() => [
      (_ctx.show)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode("div", {
              class: "flex p-2 px-4 m-2 text-white border rounded shadow-2xl cursor-pointer pointer-events-auto bg-background border-highlight",
              onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)), ["stop"])),
              "data-testid": "toast-component"
            }, [
              _createVNode("div", _hoisted_2, _toDisplayString(_ctx.message), 1),
              _createVNode("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
                class: "flex items-center ml-2 focus:outline-none"
              }, [
                _createVNode(_component_fa, {
                  icon: "times",
                  type: "fas",
                  class: "pl-1",
                  height: "18"
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
})